<div class="container py-5">
    <div class="row">
        <div class="col-4 offset-4">
            <div class="card border-0 shadow mt-5">
                <div class="card-body p-5">

                    <label>Login to</label>
                    <h3 class="my-0">
                        <div class="font-size-1-half"><strong>Dynamic Discount Dashboard</strong></div>
                    </h3>
                    <small class="text-muted">ver. 3.2.4</small>

                    <div class="alert alert-danger mt-3" *ngIf="authenticationError">
                        <div><strong>Failed to log in!</strong></div>
                        <div>Please check your credentials and try again.</div>
                    </div>


                    <div class="d-flex align-items-center mt-4 opacity-50">
                        <hr class="flex-grow-1">
                        <small class="text-muted text-uppercase mx-3">login via single sign-on</small>
                        <hr class="flex-grow-1">
                    </div>
                    <button class="btn btn-secondary w-100" type="submit" (click)="redirectToSsoUrl()"
                        [disabled]="logging">
                        <i class="fa fa-sign-in me-2" aria-hidden="true"></i>
                        {{ logging ? 'Logging in...' : 'Single Sign-on' }}
                    </button>

                    <form (ngSubmit)="login()" [formGroup]="loginForm">
                        <div class="d-flex align-items-center mt-4 opacity-50">
                            <hr class="flex-grow-1">
                            <small class="text-muted text-uppercase mx-3">or use username/password</small>
                            <hr class="flex-grow-1">
                        </div>

                        <div class="input-group mb-3">
                            <span class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></span>
                            <input formControlName="username" id="username" placeholder="Enter Username" type="text"
                                class="form-control" />
                        </div>

                        <div class="input-group mb-3">
                            <span class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></span>

                            <input autocomplete="off" id="password" class="form-control" formControlName="password"
                                placeholder="Enter Password" type="password" />
                        </div>

                        <button class="btn btn-primary w-100" type="submit" [disabled]="logging">
                            <i class="fa fa-sign-in me-2" aria-hidden="true"></i>{{ logging ? 'Logging in...' : 'Login'
                            }}
                        </button>
                    </form>


                </div>
            </div>
        </div>
    </div>
</div>